import React from "react";
import { Collapse } from "antd";
import { Link } from "react-router-dom";
import HelpSectionHeader from "./HelpSectionHeader";
import { careItems } from "./helpPage.data";
import { HelpFaqSectionProps } from "../interfaces";

import "./HelpFaqSection.scss";



const faqItems = [
  {
    key: "1",
    label: <span id="ring-size-guide">How do I measure ring size at home?</span>,
    children: (
      <>
        <ol>
          <li>Wrap a strip of paper or string around the base of the finger.</li>
          <li>Mark where the material overlaps.</li>
          <li>Measure the length with a ruler.</li>
          <li>Compare the measurement with a ring size chart.</li>
        </ol>
        <p>
          Measure near the end of the day and avoid measuring cold fingers,
          because finger size can change slightly with temperature.
        </p>
      </>
    ),
  },
  {
    key: "2",
    label: <span id="jewelry-care">How should I care for jewelry?</span>,
    children: (
      <>
        <ul>
          {careItems.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
        <p>
          For valuable or delicate pieces, periodic professional cleaning is
          still recommended.
        </p>
      </>
    ),
  },
  {
    key: "3",
    label: "What should I check before adding a product to cart?",
    children: (
      <p>
        Review the product images, selected material, available sizes,
        material-specific stock, and price. If a product has comments, they
        can also help confirm the piece before purchase.
      </p>
    ),
  },
  {
    key: "4",
    label: "Where can I see my order after payment?",
    children: (
      <p>
        Paid orders appear in your{" "}
        <Link to="/UserPage/order-history">account order history</Link> with
        the order total and the purchased product details such as material,
        size, and quantity.
      </p>
    ),
  },
  {
    key: "5",
    label: "Can I use Stripe or PayPal?",
    children: (
      <p>
        The checkout is designed to support both Stripe and PayPal payment
        paths. The available option depends on the current checkout setup and
        payment configuration.
      </p>
    ),
  },
];

const HelpFaqSection: React.FC<HelpFaqSectionProps> = ({ activeKey, onChange }) => (
  <section className="help-section help-faq-section">
    <HelpSectionHeader
      title="Guides and FAQ"
      text="Practical details customers usually need before placing an order."
    />

    <Collapse
      accordion
      activeKey={activeKey}
      onChange={onChange}
      className="help-collapse"
      bordered={false}
      items={faqItems}
    />
  </section>
);

export default HelpFaqSection;
